<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>View Health Card</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3">
            <p><b>Academic Year*</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined />
          </v-col>
          <v-col cols="12" sm="4" md="2" v-if="ay">
            <br />
            <v-btn class="button mt-5" color="primary" rounded small @click="fetchEmpHealthCards()">Fetch
              Employee</v-btn>
          </v-col>
          <v-col cols="12" sm="4" md="2" v-if="ay">
            <br />
            <v-btn class="button mt-5" color="primary" :loading="fetch_loader" rounded small @click="fetchStudHealthCards()">Fetch
              Student</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="healthCardDetails_list.length > 0">
        <v-data-table :headers="headers" :items="healthCardDetails_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title> Employee Health Cards</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.view`]="{ item }" >
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="green" @click="viewMedicalForm(item)">mdi-eye</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.unapprove`]="{ item }">
            <v-btn class="button" color="red" @click="unapproveMedicalForm(item)">Unapprove</v-btn>
          </template>
          <template v-slot:[`item.add_treatment`]="{ item }">
            <v-btn class="button" color="green" @click="addTreatment(item)">Add Treatment</v-btn>
          </template>
        </v-data-table>
      </v-card>
      <v-card class="box" v-if="all_stud_hc_list.length>0">
        <v-row dense class="pa-3">
          <v-col cols="12" sm="3">
                <v-autocomplete v-model="selectedStandard" :items="standard_list" item-text="name" item-value="id"
                  label="Select Standard" outlined dense @change="getDivisions(selectedStandard)" clearable/>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete v-model="selectedDivision" :items="division_list" item-text="name" item-value="div_id"
              label="Select Division" outlined dense clearable/>
          </v-col>
        </v-row>

        <v-data-table :headers="stud_headers" :items="stud_hc_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Student Health Cards</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.view_form`]="{ item }">
            <v-avatar size="35" >
              <v-icon class="mr-4 v-icon-size" color="green" @click="viewStudentMedicalForm(item)">mdi-eye</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.add`]="{ item }">
            <v-avatar size="35" >
              <v-icon class="mr-4 v-icon-size" color="blue" @click="createHealthCard(item)">mdi-plus-circle</v-icon>
            </v-avatar>
          </template>
          <template v-slot:[`item.add_treatment`]="{ item }">
            <v-btn class="button" color="green" @click="addStudTreatment(item)">Add Treatment</v-btn>
           
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog_stud_add_treatment" style="margin-top: 10%" fullscreen hide-overlay
        transition="dialog-top-transition">
        <v-card class="box">
          <!-- hi : {{ curr_stud_hc }} <br /><br />
          cc-{{ child_div_id }} -->
          <v-toolbar dark color="primary">
            <v-toolbar-title>Add Treatment</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="dialog_stud_add_treatment = false"><v-icon>mdi-close</v-icon>Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <br />
            <v-row dense justify="center">
              <v-col cols="12" sm="8" md="8">
                <p><b></b></p>
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="hprob.nature_hprob"
                  name="nature_hprob" label="Nature of Problem"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense justify="center">
              <v-col cols="12" sm="8" md="8">
                <p><b></b></p>
                <v-text-field rounded outlined color="#0F2027" flat dense v-model="hprob.remark" name="remark"
                  label="Remark"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense justify="center">
              <v-col cols="12" sm="4" md="4">
                <!-- <p><b>Date</b></p> -->
                <v-text-field outlined dense type="date" v-model="hprob.hprob_date"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense justify="center">
    <v-col cols="12" sm="8" md="8">
      <v-textarea rows="2" rounded outlined dense v-model="hprob.medication_administered"
        label="Medication Administered"></v-textarea>
    </v-col>
  </v-row>
  <v-row dense justify="center">
    <v-col cols="12" sm="8" md="8">
      <v-textarea rows="2" rounded outlined dense v-model="hprob.name_of_medical_professional"
        label="Name of Attending Person / Medical Professional"></v-textarea>
    </v-col>
  </v-row>
          </v-card-text>
          <!-- <br /> -->
          <v-row justify="center">
            <v-btn class="button" absolute :disabled="
                hprob.nature_hprob.length > 0 &&
                hprob.remark.length > 0 &&
                hprob.hprob_date != null
                  ? false
                  : true
              " @click="saveChildHealthProblem()">Add Student Health Problem</v-btn>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog_add_treatment" style="margin-top: 10%" fullscreen hide-overlay
        transition="dialog-top-transition">
        <v-card class="mx-auto">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Add Treatment</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="dialog_add_treatment = false"><v-icon>mdi-close</v-icon>Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <br />
          <v-card-text>
            <v-card class="box">
              <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Add Treatment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
              <br />
              <!-- Health card data- {{ inst_health_card_data }} <br /><br /> -->
              <center>
                <h3 style="text-transform: uppercase">
                  <b>{{ inst_health_card_data.organization_name }}</b>
                </h3>

                <h3 style="text-decoration: underline; text-transform: uppercase">
                  <b>MEDICAL/HEALTH CARD FOR SCHOOL</b>
                </h3>
              </center>
              <br />
              <v-row dense class="inst-details">
                <v-col cols="12" sm="6" md="6">
                  <v-row dense>
                    <v-col cols="12" sm="2" md="2"> Name- </v-col>
                    <v-col cols="12" sm="10" md="10">
                      {{ inst_health_card_data.inst_name }}
                      <hr />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-row dense>
                    <v-col cols="12" sm="5" md="5"> Employee Id- </v-col>
                    <v-col cols="12" sm="7" md="7">
                      {{ inst_health_card_data.inst_employee_id }}
                      <hr />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row dense class="inst-details">
                <v-col cols="12" sm="3" md="3">
                  <v-row dense>
                    <v-col cols="12" sm="5" md="3"> Gender- </v-col>
                    <v-col cols="12" sm="7" md="9">
                      {{ inst_health_card_data.gender }}
                      <hr />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-row dense>
                    <v-col cols="12" sm="2" md="3"> Age- </v-col>
                    <v-col cols="12" sm="2" md="9">
                      {{ inst_health_card_data.age }}
                      <hr />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <br />
              <hr />
              <br />
              <v-row dense justify="center">
                <v-col cols="12" sm="5" md="5">
                  Date ::
                  <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                </v-col>
              </v-row>
              <v-row dense class="inst-details" justify="center">
                <v-col cols="12" sm="5" md="5">
                  <v-textarea rows="3" rounded outlined color="#0F2027" flat dense v-model="health_concern"
                    label="Health Concern"></v-textarea>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                  <v-textarea rows="3" rounded outlined color="#0F2027" flat dense v-model="medication_administered"
                    label="Medication Administered"></v-textarea>
                </v-col>
              </v-row>
              <v-row dense class="inst-details" justify="center">
                <v-col cols="12" sm="5" md="5">
                  <v-textarea rows="3" rounded outlined color="#0F2027" flat dense
                    v-model="name_of_medical_professional"
                    label="Name Of Attending Person/Medical Professional"></v-textarea>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                  <v-textarea rows="3" rounded outlined color="#0F2027" flat dense v-model="remark"
                    label="Remark"></v-textarea>
                </v-col>
              </v-row>

              <v-row justify="center" dense>
                <v-col cols="12" sm="1">
                  <v-btn class="button" color="primary" rounded small @click="saveMedialTreatment()">Save</v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import ViewInstructorHealthCard from "./ViewInstructorHealthCard";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    "view-instructor-health-card": ViewInstructorHealthCard,
    Breadcrumbs

  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    dialog_add_treatment: false,
    dialog_stud_add_treatment: false,
    // extraBreadcrumbItems: [
     

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    usertype:"",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    healthCardDetails_list: [],
    stud_hc_list: [],
    inst_health_card_data: [],
    ay: "",
    health_concern: "",
    medication_administered: "",
    name_of_medical_professional: "",
    remark: "",
    medical_form_id: "",
    fromdate: null,
    selectedStandard: null,
    selectedDivision: null,
    standard_list: [],
    division_list: [],
    all_stud_hc_list: [],
    fetch_loader:false,

    headers: [
      { text: "SR No", value: "count" },
      { text: "Application Date", value: "approval_date" },
      { text: "Name", value: "patient" },
      { text: "View Form", value: "view" },
      { text: "Un-Approve", value: "unapprove" },
      { text: "Add Treatment", value: "add_treatment" },
    ],
    stud_headers: [
      { text: "SR No", value: "count" },
      { text: "Application Date", value: "approval_date" },
      { text: "Name", value: "patient" },
      { text: "Add details", value: "add" },
      { text: "Add Treatment", value: "add_treatment" },
      { text: "View form", value: "view_form" },
    ],
    curr_stud_hc: null,
    hprob: {
      hprob_date: "",
      nature_hprob: "",
      remark: "",
    },
    child_div_id: "",
  }),
  methods: {
    async saveChildHealthProblem() {
      const formdata = {
        form_id: this.curr_stud_hc.id,
        hprob_date: this.hprob.hprob_date,
        nature_hprob: this.hprob.nature_hprob,
        remark: this.hprob.remark,
        health_problem_date:   this.hprob.hprob_date   || null,
  health_problem_nature: this.hprob.nature_hprob || "",
  health_problem_remark: this.hprob.remark       || "",
  
        health_problem_medication_administered: this.hprob.medication_administered || "",
        health_problem_name_of_medical_professional: this.hprob.name_of_medical_professional || "",
        user: this.usertype,
        ay: this.ay,
        child_div_id : this.curr_stud_hc.learner_div
      };
      console.log("hprob", formdata);
      try {
        const res = await axios.post(
          "/healthCard/saveChildHealthProblem",
          formdata
        );
        console.log("result", res);
        if (res.data.flag == "YES") {
          this.showSnackbar("green", res.data.snackbar);
          this.hprob_list = res.data.hprob_list;
        } else {
          this.showSnackbar("error", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        // this.other_info = false;
        //this.res = res
      } catch (err) {
        this.onerror(err);
      } finally {
        this.dialog_stud_add_treatment = false;
        this.hprob.hprob_date = "",
        this.hprob.nature_hprob = "",
        this.hprob.remark = "",
        this.hprob.medication_administered = "",
        this.hprob.name_of_medical_professional = "",
        this.fetchStudHealthCards()
      }
    },
    addStudTreatment(item) {
      // alert(JSON.stringify(item))
      console.log(item);
      this.curr_stud_hc = item;
      this.dialog_stud_add_treatment = true;
    },
    saveMedialTreatment() {
      // alert(this.fromdate)
      const formData = {
        medical_form_id: this.medical_form_id,
        health_concern: this.health_concern,
        medication_administered: this.medication_administered,
        name_of_medical_professional: this.name_of_medical_professional,
        remark: this.remark,
        instructor: this.inst_health_card_data.inst_id,
        fromdate: this.fromdate,
      };
      axios
        .post("HealthCard/saveMedialTreatment", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inst_health_card_data = res.data.health_card_data;
            this.dialog_add_treatment = false;
            this.showSnackbar("green", "Treatment Added Successfully...");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    addTreatment(item) {
      this.medical_form_id = item.id;
      const formData = {
        form_id: item.id,
      };
      axios
        .post("HealthCard/addTreatment", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.inst_health_card_data = res.data.health_card_data;
            this.dialog_add_treatment = true;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },

    viewMedicalForm(item) {
      console.log(item.id);
      localStorage.setItem("medical_form_no", item.id);
      let routeData = this.$router.resolve({
        name: "view-instructor-health-card",
      });
      window.open(routeData.href, "_blank");
    },
    async viewStudentMedicalForm(item) {
      // alert(JSON.stringify(item));
      localStorage.setItem("medical_form_no", item.id);
      try {
        const res = await axios.post("/HealthCard/get_ldid_from_hc", {
          shcid: item.id,
          learner_id: item.learner_id,
          ay:this.ay
        });
        if (res.data.flag == "YES") {
          // alert(res.data.ldid)
          this.child_div_id = res.data.ldid;
          localStorage.setItem("child_div_id", res.data.ldid);
          let routeData = this.$router.resolve({
            name: "student-health-card",
          });
          window.open(routeData.href, "_blank");
        } else {
          this.showSnackbar("error", "Something went wrong...");
        }
      } catch (error) {
        console.log(error);
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
        this.save_loader = false;
      }
    },
    unapproveMedicalForm(item) {
      const formData = {
        form_id: item.id,
      };
      axios
        .post("HealthCard/unapproveMedicalForm", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.healthCardDetails_list = res.data.healthCardDetails;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetchEmpHealthCards() {
      this.stud_hc_list = [];
      this.healthCardDetails_list = [];
      const formData = {
        academicyear: this.ay,
      };
      axios
        .post("HealthCard/fetchHealthCards", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.healthCardDetails_list = res.data.healthCardDetails;
          }
          if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            return;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetchStudHealthCards() {
      this.selectedStandard=null;
      this.selectedDivision=null;
      this.stud_hc_list = [];
      this.healthCardDetails_list = [];
      this.fetch_loader = true;
      const formData = {
        academicyear: this.ay,
      };
      axios
        .post("HealthCard/fetchStudHealthCards", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.stud_hc_list = res.data.healthCardDetails;
              this.all_stud_hc_list = res.data.healthCardDetails;

              this.stud_hc_list = this.all_stud_hc_list
                .sort((a, b) => {
                  return (b.is_health_card_present === true) - (a.is_health_card_present === true);
                })
                .map((item, index) => ({
                  ...item,
                  count: index + 1
                }));
              this.standard_list = res.data.standard_list;
          }
          if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            return;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          sessionStorage.setItem("error-trace", res.data.error_trace);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.fetch_loader = false;
        });
    },
    onLoad() {
      axios
        .post("HealthCard/doctorViewForm")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.ay_list = res.data.ay_list;
            this.ay = res.data.curreny_ay;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getDivisions(standard){
      const data = {
        standard: standard,
        ay : this.ay
      }
       axios
        .post("Examination/getDivisions",data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.division_list = res.data.div_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    filterStudents() {
      let filtered = [...this.all_stud_hc_list];
      console.log("standrad======="+this.selectedStandard);
      console.log("division======="+this.selectedDivision);
      
      if (this.selectedStandard && this.selectedDivision) {
        filtered = filtered.filter(
          i =>
            i.standard_id == this.selectedStandard &&
            i.division_id == this.selectedDivision
        );
      }

      else if (this.selectedStandard) {
        filtered = filtered.filter(
          i => i.standard_id == this.selectedStandard
        );
      }

      else if (this.selectedDivision) {
        filtered = filtered.filter(
          i => i.division_id == this.selectedDivision
        );
      }

      this.stud_hc_list = filtered
        .sort((a, b) => {
          return (b.is_health_card_present === true) - (a.is_health_card_present === true);
        })
        .map((item, index) => ({
          ...item,
          count: index + 1
        }));
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    createHealthCard(item) {
      console.log("Create Health Card for:", item);
      const childDivId = item.learner_div;
      localStorage.setItem("ay", this.ay);
      localStorage.setItem("child_div_id", childDivId);

      let routeData = this.$router.resolve({
        name: "student-health-card-form", 
      });

      window.open(routeData.href, "_blank");
    }
  },
  mounted() {
    this.onLoad();
    this.usertype = localStorage.getItem("EPS-ut");
  },
  watch: {
    selectedStandard() {
      this.filterStudents();
    },
    selectedDivision() {
      this.filterStudents();
    }
  },
};
</script>
<style scoped>
input[type="date"] {
  width: 60%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.inst-details {
  text-transform: uppercase;
  font-weight: 400;
}
.inst-details span {
  /* text-decoration: underline; */
  border-bottom: 1px solid currentColor;
  display: inline-block;
}
</style>